import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Content from 'Views/Page/Content/Templates/WizardTemplates/WizardStepDetailListTemplate/Content';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import metaOverrideSet from './MetaOverrideSet';

const styles = () => ({
  root: {},
});

const DetailListTemplate = ({
  classes,
  resource,
}) => {
  return (
    <MetaFormInline
      className={classes.form}
      noIndividualSubmitButtons
      resource={resource}
      layout={Content}
      metaOverrideSet={metaOverrideSet}
      LayoutProps={{
        hideErrorList: true,
      }}
    />
  );
};

DetailListTemplate.defaultProps = {
};

DetailListTemplate.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(DetailListTemplate);
